module.exports = __webpack_public_path__ + "static/media/30.3ad96a50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/30.svg
// module id = 141
// module chunks = 0